import { AxiosError } from "axios";
import { PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import { EquipamentoDto } from "../typings";
import http from "infra/http";
import { FiltroEquipamentos } from "./../typings/index";

export function useListarEquipamentos(query: FiltroEquipamentos) {
  return useQuery<PaginateResult<EquipamentoDto>, AxiosError>(
    [`/v1/equipamento`, query],
    async () => {
      const { data } = await http.get<PaginateResult<EquipamentoDto>>(
        "/v1/equipamento",
        {
          params: query,
        }
      );

      return data;
    }
  );
}
